// lib/chat/agentIsWorking.ts
//
// IS THE AGENT ACTUALLY WORKING RIGHT NOW?
//
// Seven surfaces ask that question - the composer's send/stop button, the Enter key, the Analyst
// glow, the spreadsheet, the slides canvas, the Portal home menu - and all seven answered it with
// `chatState.length > 0`. That was true while a telemetry line only ever existed during work.
//
// It stopped being true on 2026-08-16, when a run's final count began PERSISTING instead of being
// wiped, so the user could still read "Scored 5 of 5 brands" after the pass. From that moment a
// session that had ever run one carried a line forever, every one of those surfaces read it as
// work in flight, and the composer sat on a stop button that could not be sent past. The whole
// conversation went mute while looking busy.
//
// So the question is not whether a line exists, it is whether any line is still MOVING.
import type { ChatStateItem } from '#types/types';

export function agentIsWorking(
  chatState: ChatStateItem[] | null | undefined,
  runningScriptId?: string | null,
): boolean {
  if (typeof runningScriptId === 'string' && runningScriptId.trim() !== '') return true;
  // A run's progress line is live but it is not the agent: counting it made the composer a stop
  // button for the whole run, and a page that missed the run's end stayed "busy" and mute
  // (preprod, 2026-09-26).
  return Array.isArray(chatState) && chatState.some((entry) => entry?.settled !== true && entry?.ambient !== true);
}
